import { render, staticRenderFns } from "./ProjectRestaurantMenu.vue?vue&type=template&id=030e76d4"
import script from "./ProjectRestaurantMenu.vue?vue&type=script&lang=ts"
export * from "./ProjectRestaurantMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports